module.exports = __webpack_public_path__ + "img/credit-one-club-gal-2.c771c641.jpg";